module.exports = __webpack_public_path__ + "img/Burundi.08d98d17.gif";